<template>
    <form
        action=""
        onsubmit="return false"
        class="form-styles"
    >
        <Modal
            :title="title"
            :cancel-disabled="progress"
            v-bind="$attrs"
            :class="[{ modal: minMD }, defaultActionSpacing]"
            should-open-in-bottom-sheet
            @cancel="close()"
            @close="close()"
        >
            <slot />
            <template #submit-action>
                <BtnCtaPromise
                    :label="submitText"
                    :success-label="successText"
                    :action="submitAction"
                    :delay-reset="delayReset"
                    data-testid="modal-submit"
                    @progress="() => (progress = true)"
                    @success="onSuccess"
                    @reset="onReset"
                />
            </template>
        </Modal>
    </form>
</template>

<script>
import Modal from '@components/Modal';
import BtnCtaPromise from '@components/BtnCtaPromise';
import ModalMixin from '@mixins/modalMixin';
import { useScreenSize } from '@/composables/screenSize';

export default {
    name: 'ModalForm',
    components: {
        Modal,
        BtnCtaPromise,
    },
    extends: ModalMixin,
    inheritAttrs: false,
    props: {
        delayReset: {
            type: Number,
            default: 1500,
        },
        title: {
            type: String,
            required: true,
        },
        progressText: {
            type: String,
            required: true,
        },
        submitText: {
            type: String,
            required: true,
        },
        successText: {
            type: String,
            required: true,
        },
        submitAction: {
            type: Function,
            required: true,
        },
        defaultActionSpacing: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        progress: false,
        wasSuccess: false,
        formData: undefined,
        minMD: useScreenSize().minMD,
    }),
    methods: {
        onSuccess(data) {
            this.formData = data;
            this.wasSuccess = true;
        },
        onReset() {
            this.progress = false;
            if (this.wasSuccess) this.close(this.formData);
        },
    },
};
</script>

<style lang="scss" scoped>
.modal:not(.defaultActionSpacing) :deep(.actions) {
    @apply mt-4;

    @screen md {
        @apply mt-2;
    }
}
.form-styles {
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    width: inherit;
    align-self: stretch;
}
</style>
